<script setup lang="ts">
//NEEDS Marketplace PLUGINS 09 and 10 

import { useAttrs } from 'vue'

const { imgname, tagname } = defineProps<{
  imgname: string
  tagname: string
}>()

// attrs.class and attrs.style are reactive if you bind them with :class / :style
const attrs = useAttrs()
</script>

<template>
  <img
    v-async-image="imgname"
    :alt="tagname"
    :class="attrs.class ?? 'cursor-pointer'"
    :style="attrs.style ?? 'width:70px;height:76px;'"
  />
</template>
